module.exports = __webpack_public_path__ + "static/bsas005-5b0e8901a69cb8800dbe6b9ddb974bfb.jpg";